// extracted by mini-css-extract-plugin
export var card = "index-module--card--J6Lcs";
export var cardContent = "index-module--card-content--SONjA";
export var imgHolder = "index-module--img-holder--UN+R3";
export var linkContainer = "index-module--linkContainer--SjygY";